var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99935 14.6668C3.64573 14.6668 3.30659 14.5264 3.05654 14.2763C2.80649 14.0263 2.66602 13.6871 2.66602 13.3335V2.66683C2.66602 2.31321 2.80649 1.97407 3.05654 1.72402C3.30659 1.47397 3.64573 1.3335 3.99935 1.3335H9.33268C9.54372 1.33316 9.75274 1.37457 9.9477 1.45534C10.1427 1.53612 10.3197 1.65467 10.4687 1.80416L12.8607 4.19617C13.0106 4.34517 13.1295 4.5224 13.2105 4.71761C13.2915 4.91282 13.333 5.12214 13.3327 5.3335V13.3335C13.3327 13.6871 13.1922 14.0263 12.9422 14.2763C12.6921 14.5264 12.353 14.6668 11.9993 14.6668H3.99935Z",
    stroke: "#4A5464",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 1.3335V4.66683C9.33398 4.84364 9.40422 5.01321 9.52925 5.13823C9.65427 5.26326 9.82384 5.3335 10.0007 5.3335H13.334",
    stroke: "#4A5464",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.99984L7.33333 11.3332L10 8.6665",
    stroke: "#4A5464",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestResults);
export default __webpack_public_path__ + "static/media/testResults.11e508309d8afcb4f1ad3c3482debb53.svg";
export { ForwardRef as ReactComponent };